/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, Text } from '@tonic-one/react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReportApi } from '@Apis';
import { FormatContent } from '@Types/report';
import config from '../../../config';

import BlockTitle from '../BlockTitle';
import FormatContainer from '../FormatContainer';
import { MemoTextLabel } from '../MemoTextLabel';
import { GeneralSetting } from './generalSetting';
import { ReportContent } from './ReportContent';
import { useOneTimeReportStore } from './store';
import { ReportNotification } from './Notification';
import { Footer, PDFSample, Reset, Submit } from './Footer';

const OneTimeReports = (props: { withEditPermission: boolean }) => {
  const reset = useOneTimeReportStore((store) => store.reset);

  const { t } = useTranslation();

  //state
  const formatType = 'pdf';

  // format status
  const [formatContent, setFormatContent] = useState<FormatContent>(
    config.ui.reportDefaultValue.formatContent
  );

  const queryDefault = useCallback(async () => {
    const defaultRes = await ReportApi.getDefaultSetting();
    if (defaultRes.data?.companyLogo) {
      const { companyName, displayTrendLogo, companyLogo } = defaultRes.data;
      setFormatContent({
        coverDescription: '',
        companyName,
        isTrendLogoDisplay: displayTrendLogo === 1,
        isCompanyLogoDisplay: companyLogo.displayLogo,
        fileInfo: {
          fileError: '',
          fileName: companyLogo.fileName,
          fileType: companyLogo.fileType,
          fileSize: companyLogo.fileSize,
          storageId: companyLogo.storageId,
        },
        isDefaultSettingSave: false,
      });
    } else {
      setFormatContent({
        coverDescription: '',
        companyName: '',
        isTrendLogoDisplay: true,
        isCompanyLogoDisplay: true,
        fileInfo: {
          fileError: '',
        },
        isDefaultSettingSave: false,
      });
    }
  }, []);

  const resetReportData = function () {
    reset();
    queryDefault();
  };

  // init
  useEffect(() => {
    queryDefault();
  }, []);

  return (
    <>
      <Box pb="175px">
        <Box px="6x" pb="6x">
          <GeneralSetting />
          <ReportContent />

          {/* Report Format */}
          <BlockTitle
            content={t('reportCommon.titles.format')}
            paddingTop="59px"
          />
          <Grid templateColumns="130px max-content" rowGap="3x">
            <MemoTextLabel label={'reportCommon.labels.format'} />
            <Grid>
              <Text pt="6px">{t(`reportCommon.labels.${formatType}`)}</Text>
              <FormatContainer
                formatContent={formatContent}
                setFormatContent={setFormatContent}
                withEditPermission={props.withEditPermission}
              />
            </Grid>
          </Grid>

          {/* Recipients */}
          <ReportNotification />
        </Box>
      </Box>

      {/* Bottom button */}
      <Footer>
        <Submit
          formatContent={formatContent}
          setFormatContent={setFormatContent}
          resetReportData={resetReportData}
        />
        <Reset onReset={queryDefault} />
        <PDFSample />
      </Footer>
    </>
  );
};

export default OneTimeReports;
